import React from 'react';

import { ErrorBoundaryFallback } from './errorBoundaryFallback';

interface Props {
  children: React.ReactNode;
  pathname: string;
}

interface State {
  error: any;
  pathname: string;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, pathname: props.pathname };
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.pathname !== state.pathname) {
      return { error: null, pathname: props.pathname };
    }

    return null;
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return <ErrorBoundaryFallback error={error} />;
    }

    return children;
  }
}
